import React from 'react';

import { HeaderNav } from '../nav/HeaderNav';

import './MainWrapper.scss';

interface MainWrapperProps {
  currentPageName: string;
  /** Big heading shown in the page hero. Defaults to the page name. */
  headerPageText?: string;
  /** Short supporting line under the page heading. */
  intro?: string;
  eyebrow?: string;
  children: React.ReactNode;
}

/**
 * Shared shell for inner pages: sticky nav + a light page-hero header,
 * followed by the page content in a centered container.
 */
export const MainWrapper: React.FC<MainWrapperProps> = ({
  currentPageName,
  children,
  headerPageText = currentPageName,
  intro,
  eyebrow,
}) => {
  return (
    <>
      <HeaderNav currentPageName={currentPageName} />
      <main id="main">
        <header className="page-hero">
          <div className="ds-container">
            {eyebrow && <span className="ds-eyebrow">{eyebrow}</span>}
            <h1>{headerPageText}</h1>
            {intro && <p className="ds-lead page-hero__intro">{intro}</p>}
          </div>
        </header>
        {children}
      </main>
    </>
  );
};

export default MainWrapper;
